module.exports = __webpack_public_path__ + "img/skip4_w.64bee5b4.svg";